module.exports = __webpack_public_path__ + "img/pixabay.3a6ab114.svg";